<template>
    <div id="approved">
        <template v-if="selectedTemplate.variables && selectedTemplate.variables.length > 0">
            <variables
                v-if="!isManageTemplatePanelActive"
                :active-chat="activeChat"
                :selected-template="selectedTemplate"
                @update:selected-template="$emit('update:selected-template', $event)"
                @reset-template="$emit('reset-template')"
                @set-template="$emit('set-template', $event)"
            />

            <manage-template
                v-else-if="isManageTemplatePanelActive"
                :selected-template="selectedTemplate"
                @reset-template="$emit('reset-template')"
            />
        </template>

        <manage-media-template
            v-else-if="showMediaTemplateManager"
            :selected-template="mediaTemplate"
            @reset-template="closeMediaTemplateManager"
        />

        <template v-else>
            <div class="templates-header d-none d-sm-block">
                <h2>
                    {{ $t("entities.templates.select-approved-templates") }}
                </h2>
                <p class="text-secondary">
                    {{ $t("entities.templates.description") }}
                </p>
            </div>

            <b-tabs v-model="activeTab" class="m-0 p-0" lazy pills>
                <b-tab :title="$t('entities.templates.text')" active>
                    <approved-text
                        :active-chat="activeChat"
                        @set-template="setTemplate"
                        @manage-template="manageTemplate"
                    />
                </b-tab>
                <b-tab :title="$t('entities.templates.media')" button-id="tab-media-templates" class="m-0 p-0">
                    <approved-media
                        :active-chat="activeChat"
                        @set-template="setTemplate"
                        @manage-media-template="openMediaTemplateManager"
                    />
                </b-tab>
            </b-tabs>
        </template>

        <div class="template-footer"></div>
    </div>
</template>

<script>
import { BTabs, BTab } from "bootstrap-vue";
import ApprovedText from "./approvedText";
import ApprovedMedia from "./approvedMedia";
import ManageTemplate from "./manageTemplate";
import ManageMediaTemplate from "./manageMediaTemplate";
import Variables from "./variables.vue";

import useActiveChatTemplates from "@/composables/useActiveChatTemplates";
import { nextTick, ref } from "@vue/composition-api";

export default {
    components: {
        BTabs,
        BTab,
        ApprovedText,
        ApprovedMedia,
        ManageTemplate,
        ManageMediaTemplate,
        Variables,
    },
    props: {
        selectedTemplate: {
            type: Object,
            required: false,
        },
        activeChat: {
            type: Object,
            required: true,
        },
    },
    methods: {
        setTemplate(template) {
            template.variables = this.fetchVariablesFromContent(template.content);
            template.originalContent = template.content;

            this.$emit("update:selected-template", template);

            // Insert directly if no variables, otherwise show new dialog with variable input fields based on value in templateVariables
            if (!template.variables) {
                this.$emit("set-template", template);
            }
        },
    },
    setup() {
        const { fetchVariablesFromContent, isManageTemplatePanelActive } = useActiveChatTemplates();
        const activeTab = ref(0);

        const manageTemplate = () => {
            isManageTemplatePanelActive.value = true;
        };

        // Media template management
        const showMediaTemplateManager = ref(false);
        const mediaTemplate = ref({});

        const openMediaTemplateManager = async (template) => {
            mediaTemplate.value = template;
            showMediaTemplateManager.value = true;
        };

        const closeMediaTemplateManager = () => {
            showMediaTemplateManager.value = false;

            nextTick(() => {
                activeTab.value = 1;
            });
        };

        return {
            isManageTemplatePanelActive,

            // Methods
            fetchVariablesFromContent,
            manageTemplate,

            // Media template management
            showMediaTemplateManager,
            openMediaTemplateManager,
            closeMediaTemplateManager,
            mediaTemplate,

            activeTab,
        };
    },
};
</script>
